import React from "react";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import immutable from "immutable";
import moment from "moment";
import LinkItem from "./link-item.jsx";

export default class Link extends React.Component {
    constructor(props) {
        super(props);
        this.state = {           
            showMore : false,
            items : []
        }

        this.loadItems = this.loadItems.bind(this);
    }

    componentDidMount() {
        this.loadItems();
    }

    loadItems() {  
        const self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        ajax.vm()
            .get(`get-links`)
            .then(function(res) {
                context.message({show:false});

                if (res.data instanceof Array)
                    self.setState({items: res.data});
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    handleClick(e, text, url) {
        e.stopPropagation();
        e.preventDefault();

        window.open(url, "_blank");
    }

    render() {         
        const visible = this.state.items.length > 0;

        var items = this.state.items.map(
            function (link, i) {
                let url = link.propertyValue;
                if (url.indexOf('.aspx') >= 0) {
                    url = baseUrl.replace('v2/', '').replace('v2', '') + '' + url;
                }
                return <LinkItem key={link.code} text={link.codeName} url={url} onClick={this.handleClick} icon="fa fa-download ap-link-icon" />
            }
            , this);


        return (
            <div className={visible ? "ap-link-panel" : "ap-hidden"}>
                <h4 className="ap-link-panel-header body-text"><i className="fa fa-link fa-2"></i>Common Links</h4>
                <ul className="no-bullet">
                    {items}
                </ul>
            </div>
        );
    }
}